import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Table as AuiTable, PageContent} from 'aui-react';
import {connect} from 'react-redux';

import Row from './Row';

export class Table extends PureComponent {
    static propTypes = {
        events: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.node)).isRequired,
    };

    static contextTypes = {
        i18n: PropTypes.func,
    };

    render() {
        if (this.props.events.length === 0) {
            return null;
        }

        return (
            <PageContent>
                <AuiTable>
                    <thead>
                        <tr>
                            <th width="40%">
                                {this.context.i18n('johnson.legacy.columnheading.description')}
                            </th>
                            <th width="10%">
                                {this.context.i18n('johnson.legacy.columnheading.time')}
                            </th>
                            <th>
                                {this.context.i18n('johnson.legacy.columnheading.level')}
                            </th>
                            <th width="40%">
                                {this.context.i18n('johnson.legacy.columnheading.exception')}
                            </th>
                        </tr>
                    </thead>
                    <tbody data-wd-id="old-events-table">
                        {this.props.events.map((event, i) =>
                            <Row key={i} rowChildren={event} /> // eslint-disable-line react/no-array-index-key
                        )}
                    </tbody>
                </AuiTable>
            </PageContent>
        );
    }
}

const mapStateToProps = state => ({
    events: state.events.oldEvents,
});

export default connect(mapStateToProps)(Table);



// WEBPACK FOOTER //
// ./src/components/OldEventsTable/OldEventsTable.js